"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSTTemplateDTOConverter = exports.SSTTemplateDTOSchema = exports.SSTTemplateRequestDTOSchema = exports.SSTTemplateSchema = exports.SSTTemplateBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var RequestSST_1 = require("./RequestSST");
exports.SSTTemplateBaseSchema = zod_1.z.object({
    name: zod_1.z.enum(RequestSST_1.RequestSSTTypesArray),
    id: zod_1.z.string(),
});
exports.SSTTemplateSchema = exports.SSTTemplateBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
// DTO Schemas for API requests/responses
exports.SSTTemplateRequestDTOSchema = zod_1.z.object({
    name: zod_1.z.enum(RequestSST_1.RequestSSTTypesArray),
    id: zod_1.z.string().min(1, 'Template ID is required'),
});
// DTO for responses
exports.SSTTemplateDTOSchema = exports.SSTTemplateBaseSchema.extend({
    _id: zod_1.z.string(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
});
// Conversion utility class
var SSTTemplateDTOConverter = /** @class */ (function () {
    function SSTTemplateDTOConverter() {
    }
    SSTTemplateDTOConverter.convertFromModel = function (template) {
        return {
            _id: template._id.toString(),
            name: template.name,
            id: template.id,
            createdAt: template.createdAt,
            updatedAt: template.updatedAt,
        };
    };
    SSTTemplateDTOConverter.convertToRequestDTO = function (template) {
        return {
            name: template.name,
            id: template.id,
        };
    };
    return SSTTemplateDTOConverter;
}());
exports.SSTTemplateDTOConverter = SSTTemplateDTOConverter;
//# sourceMappingURL=SSTTemplates.js.map